import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';

type Store = {
	isLoading: boolean;
	isShowNavBar: boolean;
	activeTab: number,
	selectedVenueId: number,
	setState: (key: string, value: any) => void;
};
const initialState = {
	isLoading: false,
	isShowNavBar: false,
	activeTab: 0,
	selectedVenueId: 0,
};

const useGlobalStore = create<Store>()(
	devtools(
		persist(
			(set, get) => ({
				...initialState,
				setState: (key, value) => {
					console.log(key, value);
					set((s) => ({
						...s,
						[key]: value,
					}));
				},
			}),
			{
				name: 'slb-global-store',
				version: 1,
			}
		)
	)
);
export default useGlobalStore;
